// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NonProdBanner-module__customLogoImageDimensions--LoqDp{max-width:186px;max-height:36px}.NonProdBanner-module__banner--YtW79{position:absolute;top:-1.667rem;right:0;left:0;height:1.667rem;display:flex;flex-flow:row nowrap;align-items:center;justify-content:center;background-color:var(--xm-normal-color);color:var(--xm-inverted-text-color);font-size:.75rem;z-index:100}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"customLogoImageDimensions": "NonProdBanner-module__customLogoImageDimensions--LoqDp",
	"banner": "NonProdBanner-module__banner--YtW79"
};
export default ___CSS_LOADER_EXPORT___;
